'use strict';

var ShareTypes = require('../constants/ShareTypes');

function getShareServiceTitle(service) {
  switch (service) {
  case ShareTypes.FACEBOOK:
    return 'Facebook';
  case ShareTypes.TWITTER:
    return 'Twitter';
  case ShareTypes.GOOGLE:
    return 'Google';
  case ShareTypes.PINTEREST:
    return 'Pinterest';
  case ShareTypes.TUMBLR:
    return 'Tumblr';
  default:
    throw new Error(`Unknown service: ${service}`);
  }
}

module.exports = getShareServiceTitle;


/** WEBPACK FOOTER **
 ** ./utils/getShareServiceTitle.js
 **/